'use client';
import AppLayout from '@/components/AppLayout';
import SettlementProcessor from './components/SettlementProcessor';

export default function SettlementProcessorPage() {
  return (
    <AppLayout portalRole="finance">
      <SettlementProcessor />
    </AppLayout>
  );
}
